import { IFilterKey, IFilterKeys, IFilters } from "models/core";

export function generateUUID() {
	var d = Date.now();
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
		var r = (d + Math.random() * 16) % 16 | 0;
		d = Math.floor(d / 16);
		return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
	});
}



/**
 * Execute a head request to determine if a given url is accessible
 */
export function serverExists(url: string, callback: (exists: boolean) => void) {
	// if (isIeBrowser())
	// 	return callback(true);

	if (!window.XMLHttpRequest)
		return callback(false);

	try {
		const xhr = new XMLHttpRequest();
		xhr.open("GET", url);
		xhr.timeout = 2000;
		xhr.onreadystatechange = function () {
			if (xhr.readyState === 4) {
				const status = xhr.status;
				if (status >= 200 && status < 400) {
					callback(true);
				} else {
					//Circumvent CORS, try load image
					const canary = document.createElement("img");
					canary.onerror = (..._args) => {
						//image does not exist (no favicon) or any other error
						callback(false);
					};
					canary.onload = () => {
						//image exists but cors blocked
						callback(true);
					};
					const u = new URL(url);
					canary.src = u.origin + "/favicon.ico";
				}
			}
		};

		xhr.send();
	} catch (error) {
		console.error(error);
		callback(false);
	}
}
